export const evubill = {
    EvuBillClass: {
        url: "Finanzierung/evu",
        defaultSegment: "Finanzierung",
        forceRefresh: false,
        receiveType: 'RECEIVE_EvuBillClass_evubillReducer'
    }
};